<template>
  <div style='height:100%'>
    <image-selector ref="imageSelector" @returnImageUrl="(url)=>{handleImg(url)}" :company-id="companyId" :project-id="projectId"/>
    <div v-if='!read_only' style='width: 100px;margin-bottom: 10px;display: flex;'>
      <el-button v-if='!edit' @click='handleShow()' type='primary'>&nbsp;预&nbsp;&nbsp;&nbsp;&nbsp;览&nbsp;</el-button>
      <el-button v-if='!edit' @click='saveInfo()' type='success' class='u-m-l-20'>&nbsp;保&nbsp;&nbsp;&nbsp;&nbsp;存&nbsp;</el-button>
    </div>
    <div v-if='!read_only' style='height: 100%;'>
      <div id="container" style="width: 100%; height: 100%;"></div>
    </div>
    <div v-else style='height: 1080px;'>
      <div id="container" style="width: 100%; height: 1080px;"></div>
    </div>
    <el-dialog title="添加组件" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <el-dialog title="选择变量" :visible.sync="selectVariableVisible" width="50%" append-to-body>
        <el-table :data="varList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="id" label="id" width="40" show-overflow-tooltip/>
          <el-table-column prop="variableName" label="变量名称" width="100" show-overflow-tooltip/>
          <el-table-column prop="description" label="变量描述" width="200" show-overflow-tooltip/>
          <el-table-column prop="curValue" label="变量当前值" min-width="100" show-overflow-tooltip/>
          <el-table-column label="操作" width="100">
            <template v-slot="scope">
              <el-button v-if='!checkVariableInList(scope.row.id)' type='success' @click='handleVariable(scope.row.id)'>
                添加
              </el-button>
              <el-button v-else type='warning' @click='handleVariable(scope.row.id)'>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-form :model="markerInfo" :rules="markerInfoRules" ref="addFormRef" label-width="100px">

        <el-form-item label="跳转页面">

          <el-dropdown @command='selectActionProduct'>
            <el-button type="primary">
              {{ markerInfo.productName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(e,i) in productList" :key='i' :command='i'>{{ e.title }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-radio class='u-m-l-50' v-model="markerInfo.actionType" label="-1">不跳转</el-radio>
          <el-radio v-model="markerInfo.actionType" label="0">跳转</el-radio>
        </el-form-item>
        <el-form-item label="变量">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="selectVariableVisible=true">
            {{ imageCountInfo }}
          </el-button>
        </el-form-item>
        <el-form-item label="图片">
          <img v-if='markerInfo.icon' style="width: 80px;height:80px" :src='markerInfo.icon+companySuffix'/>
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="openImageSelectionDialog"></el-button>
        </el-form-item>
        <el-form-item label="经度" prop="lng">
          <el-input v-model="markerInfo.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="lat">
          <el-input v-model="markerInfo.lat"></el-input>
        </el-form-item>
        <el-form-item label="图片高" prop="height">
          <el-input v-model="markerInfo.height"></el-input>
        </el-form-item>
        <el-form-item label="图片宽" prop="width">
          <el-input v-model="markerInfo.width"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
				<el-button @click="addDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addMarker()">确 定</el-button>
			</span>
    </el-dialog>

    <el-dialog title="编辑组件" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-dialog title="选择变量" :visible.sync="selectVariableVisible" width="50%" append-to-body>
        <el-table :data="varList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="id" label="id" width="40" show-overflow-tooltip/>
          <el-table-column prop="variableName" label="变量名称" width="100" show-overflow-tooltip/>
          <el-table-column prop="description" label="变量描述" width="200" show-overflow-tooltip/>
          <el-table-column prop="curValue" label="变量当前值" min-width="100" show-overflow-tooltip/>
          <el-table-column label="操作" width="100">
            <template v-slot="scope">
              <el-button v-if='!checkVariableInList(scope.row.id)' type='success' @click='handleVariable(scope.row.id)'>
                添加
              </el-button>
              <el-button v-else type='warning' @click='handleVariable(scope.row.id)'>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>


      <el-form :model="markerInfo" :rules="markerInfoRules" ref="editFormRef" label-width="100px">
        <el-form-item label="跳转页面">

          <el-dropdown @command='selectActionProduct'>
            <el-button type="primary">
              {{ markerInfo.productName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(e,i) in productList" :key='i' :command='i'>{{ e.title }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-radio class='u-m-l-50' v-model="markerInfo.actionType" label="-1">不跳转</el-radio>
          <el-radio v-model="markerInfo.actionType" label="0">跳转</el-radio>
        </el-form-item>
        <el-form-item label="变量">
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="selectVariableVisible=true">
            {{ imageCountInfo }}
          </el-button>
        </el-form-item>
        <el-form-item label="图片" prop="province">
          <img v-if='markerInfo.icon' style="width: 80px;height:80px" :src='markerInfo.icon+companySuffix'/>
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="openImageSelectionDialog">
          </el-button>
        </el-form-item>
        <el-form-item label="经度" prop="lng">
          <el-input v-model="markerInfo.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="lat">
          <el-input v-model="markerInfo.lat"></el-input>
        </el-form-item>
        <el-form-item label="图片高" prop="height">
          <el-input v-model="markerInfo.height"></el-input>
        </el-form-item>
        <el-form-item label="图片宽" prop="width">
          <el-input v-model="markerInfo.width"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
				<el-button type='danger' @click="deleteMarker(editMarkerIndex)">删 除</el-button>
				<el-button @click="editDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editMarker(editMarkerIndex)">确 定</el-button>
			</span>
    </el-dialog>
    <el-dialog
        title="提示"
        :visible.sync="exitDialogVisible"
        width="30%"
        >
      <span>是否确认离开此页面(若未保存将丢失修改记录)？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelExit">取 消</el-button>
        <el-button type="primary" @click="confirmExit">确 定</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/../config/api.js";

let map, self;
var mapObj;
import {TMap} from '@/../config/TMap';
import ImageSelector from "@/components/ImageComponents/ImageSelector";
import {generatePath, handleRedirect} from "@/../config/redirectWindow"
export default {
  /* eslint-disable */
  props: ['companyId', 'productId', 'projectId', "data", "read_only","is_show"],
  components:{
    ImageSelector
  },
  data() {
    return {
      mapInit: false,

      edit: false,
      //存储地图上的标记点 marker
      markers: [],
      //存储每一个marker 对应的点击/跳转逻辑
      actions: [],
      //存储每一个marker 对应的图像url
      imgUrls: [],

      //ui交互时的绑定数据
      markerInfo: {
        lat: 0,
        lng: 0,
        height: 30,
        width: 30,
        icon: null,
        varIds: [],//显示变量信息
        //跳转页面信息
        productId: null,
        productName: "请选择",
        productType: null,
        actionType: "-1",//-1 不跳转 0 跳转
      },
      markerInfoJSON: [],//前后端交互使用

      addDialogVisible: false,
      editDialogVisible: false,
      editMarkerIndex: -1,

      selectVariableVisible: false,
      markerInfoRules: {},

      header: {
        "Content-Type": "application/x-www-form-urlencoded"
      },

      //info
      infoDialog: {},
      //变量、项目列表
      varList: [],
      productList: [],
      //跳转页面的Dialog
      exitDialogVisible: false,
      //退出使用
      exitFunc: null,
      exitNode: null

    }
  },
  async mounted() {
    self = this;
    console.log("init");
    console.log(this.read_only);
    if (this.read_only) {
      this.edit = true;
      this.mapId = "container_2"
    }
    this.initMap();
    this.checkMapInit();
  },
  computed: {
    //应该要改
    imageCountInfo() {
      if (!this.markerInfo.varIds) {
        return "未选择变量"
      } else {
        let count = 0;
        for (let index in this.markerInfo.varIds) {
          if (this.markerInfo.varIds[index]) {
            ++count;
          }
        }
        if (count === 0) return "未选择变量";
        return `选择了${count}个变量`
      }
    }
  },
  methods: {
    checkMapInit() {
      if (this.mapInit) {
        this.initVariableList();
        this.getProductPublishedList();
        this.initInfo();
        return;
      }
      setTimeout(()=>{
        self.checkMapInit()
      },100)
    },
    openImageSelectionDialog(){
      this.$refs.imageSelector.openDialog();
    },
    async initMap() {
      //为了初始化坐标位置
      let mapPosition = ''
      let data = {
        id: this.productId,  // 页面id
        companyId: this.companyId
      }
      await this.$axiosRequest({
        url: API.getProductById,
        method: 'POST',
        data: data,
        header: this.header,
        success: res => {
          mapPosition = JSON.parse(res.data.product.tableData);
        }
      })
      console.log(mapPosition);
      TMap('LIUBZ-SVY6W-F4GRA-OS3BN-XZY33-44FRJ').then((qq) => {
        let str = "container";
        map = new qq.maps.Map(document.getElementById(str), {
          // 地图的中心地理坐标。
          center: (mapPosition.center)?new qq.maps.LatLng(mapPosition.center.lat, mapPosition.center.lng):new qq.maps.LatLng(39.916527, 116.397128),
          zoom: (mapPosition.zoom)?mapPosition.zoom:8
        });

        qq.maps.event.addListener(map, "click", function (e) {
          if (!self.edit) {
            self.clearMarkerInfo();
            self.markerInfo.lat = e.latLng.getLat().toFixed(6);
            self.markerInfo.lng = e.latLng.getLng().toFixed(6);
            self.addDialogVisible = true;
          }
        });
        self.mapInit = true;
      });
    },
    clearMarkerInfo(){
      this.markerInfo= {
        lat: 0,
        lng: 0,
        height: 30,
        width: 30,
        icon: null,
        varIds: [],//显示变量信息
        //跳转页面信息
        productId: null,
        productName: "请选择",
        productType: null,
        actionType: "-1",//-1 不跳转 0 跳转
      }
    },
    async autoAddMarker(bin) {
      console.log(bin);
      bin.lat = parseFloat(bin.lat);
      bin.lng = parseFloat(bin.lng);
      bin.height = parseInt(bin.height);
      bin.width = parseInt(bin.width);
      var index = this.markers.length;
      this.markers.push(new qq.maps.Marker({
        position: new qq.maps.LatLng(bin.lat, bin.lng),
        map: map,
      }));
      this.actions.push({
        productId: bin.productId,
        productName: bin.productName,
        productType: bin.productType,
        actionType: bin.actionType,
        varIds: bin.varIds
      })
      this.imgUrls.push(bin.icon);
      var action = "";
      if (bin.actionType != '-1') {
        action = await this.generateActionUrl(bin);
      }

      this.markers[index].setIcon(
          new qq.maps.MarkerImage(
              bin.icon + this.companySuffix,
              new qq.maps.Size(bin.width, bin.height),
              new qq.maps.Point(0, 0),
              new qq.maps.Point(bin.width / 2, bin.height / 2),
              new qq.maps.Size(bin.width, bin.height),
          ));
      this.addListener(index, action);
    },
    async addMarker() {
      this.markerInfo.lat = parseFloat(this.markerInfo.lat);
      this.markerInfo.lng = parseFloat(this.markerInfo.lng);
      var action = "";
      if (this.markerInfo.actionType != '-1') {
        action = await this.generateActionUrl(this.markerInfo);
      }

      if (!this.validate()) {
        return;
      }
      var index = this.markers.length;
      this.markers.push(new qq.maps.Marker({
        position: new qq.maps.LatLng(this.markerInfo.lat, this.markerInfo.lng),
        map: map,
      }));
      this.actions.push({
        productId: this.markerInfo.productId,
        productName: this.markerInfo.productName,
        productType: this.markerInfo.productType,
        actionType: this.markerInfo.actionType,
        varIds: this.markerInfo.varIds
      })
      this.updateMarker(index, action);
      this.addDialogVisible = false;
      this.clearMarkerInfo();
    },
    async editMarker(index) {
      this.markerInfo.lat = parseFloat(this.markerInfo.lat);
      this.markerInfo.lng = parseFloat(this.markerInfo.lng);
      var action = "";
      if (this.markerInfo.actionType != '-1') {
        action = await this.generateActionUrl(this.markerInfo);
      }
      this.$refs.editFormRef.validate(async () => {
        self.markers[index].setMap(null);
        self.markers[index] = new qq.maps.Marker({
          position: new qq.maps.LatLng(this.markerInfo.lat, this.markerInfo.lng),
          map: map
        });
        this.actions[index] = {
          productId: this.markerInfo.productId,
          productName: this.markerInfo.productName,
          productType: this.markerInfo.productType,
          actionType: this.markerInfo.actionType,
          varIds: this.markerInfo.varIds
        }
        this.updateMarker(index, action);
        this.editDialogVisible = false;
        this.clearMarkerInfo();
      })
    },
    //检验参数是否合法
    validate() {

      this.markerInfo.lat = parseFloat(this.markerInfo.lat);
      this.markerInfo.lng = parseFloat(this.markerInfo.lng);
      if (this.markerInfo.lat.toString == "NaN" || this.markerInfo.lng.toString == "NaN") {
        this.$message({
          message: '经纬度必须为数字',
          type: "error"
        });
        return false;
      }
      this.markerInfo.height = parseInt(this.markerInfo.height);
      this.markerInfo.width = parseInt(this.markerInfo.width);
      if (this.markerInfo.height <= 0 || this.markerInfo.height >= 1000 || this.markerInfo.width <= 0 || this.markerInfo.width >= 1000) {
        this.$message({
          message: '图片长宽必须为0-1000内数字',
          type: "error"
        });
        return false;
      }
      if (!this.markerInfo.icon) {
        this.$message({
          message: '请选择图片',
          type: "error"
        });
        return false;
      }
      if (!this.markerInfo.productId && this.markerInfo.actionType != '-1') {
        this.$message({
          message: '请选择跳转页面',
          type: "error"
        });
        return false;
      }
      return true;
    },
    addDialogClosed() {

    },
    editDialogClosed() {

    },
    //父组件点击树状图其它节点切换的时候提醒保存
    change(func, node) {
      this.exitDialogVisible = true;
      this.exitFunc = func;
      this.exitNode= node;
    },
    //取消退出
    cancelExit(){
      this.exitDialogVisible = false;
      this.$emit('testback');
    },
    confirmExit(){
      this.exitDialogVisible = false;
      this.exitFunc(this.exitNode);
    },
    async generateActionUrl(bin) {
      return generatePath(bin.productId,this.companyId,this.productId);
    },
    updateMarker(index, action) {
      self.markerInfo.height = parseInt(self.markerInfo.height);
      self.markerInfo.width = parseInt(self.markerInfo.width);

      this.markers[index].setIcon(
          new qq.maps.MarkerImage(
              self.markerInfo.icon + this.companySuffix,
              new qq.maps.Size(self.markerInfo.width, self.markerInfo.height),
              new qq.maps.Point(0, 0),
              new qq.maps.Point(self.markerInfo.width / 2, self.markerInfo.height / 2),
              new qq.maps.Size(self.markerInfo.width, self.markerInfo.height),
          ));
      this.imgUrls[index] = self.markerInfo.icon;
      this.addListener(index, action);

    },
    addListener(index, action) {
      qq.maps.event.addListener(this.markers[index], 'click', function () {
        if (!self.edit) {
          self.markerInfo.icon = self.markers[index].getIcon().url;
          self.markerInfo.lat = self.markers[index].position.lat;
          self.markerInfo.lng = self.markers[index].position.lng;
          self.markerInfo.height = self.markers[index].getIcon().size.getHeight();
          self.markerInfo.width = self.markers[index].getIcon().size.getWidth();
          self.markerInfo.productId = self.actions[index].productId;
          self.markerInfo.productType = self.actions[index].productType;
          self.markerInfo.actionType = self.actions[index].actionType;
          self.markerInfo.productName = self.actions[index].productName;
          self.markerInfo.varIds = self.actions[index].varIds;

          self.editMarkerIndex = index;
          self.editDialogVisible = true;
        } else {

          var flag = false;
          var doAction = false;

          var content = `<div style="width:300px;">`;
          for (var i in self.actions[index].varIds) {
            if (self.actions[index].varIds[i]) {
              content += "<div>";
              content += self.getDataByVarId(i);
              content += "</div>";
              flag = true;
            }
          }
          content += "</div>"
          var dom = document.createElement('div' + index);
          dom.innerHTML = content;

          //如果没有要加的变量
          if (!flag) {
            doAction = true;
          }
          //以前未初始化对话框
          else if (!self.infoDialog[index]) {
            self.infoDialog[index] = new qq.maps.InfoWindow({
              map: map,
              content: dom,
              position: self.markers[index],
              zIndex: 10,
              visible: true
            });
            //初始化过，但关闭了
          } else if (self.infoDialog[index]["visible"] == false) {
            self.infoDialog[index].setMap(null);
            self.infoDialog[index] = new qq.maps.InfoWindow({
              map: map,
              content: dom,
              position: self.markers[index],
              zIndex: 10,
              visible: true
            });
          } else {
            doAction = true;
          }
          if (action && doAction) {
            console.log("wowowowowo")
            handleRedirect(action);
          }
        }
      });
    },
    deleteMarker(index) {
      this.markers[index].setMap(null);
      this.markers[index] = null;
      this.actions[index] = null;
      this.imgUrls[index] = null;
      this.editDialogVisible = false;
    },
    handleImg(url) {
      console.log(url)
      this.markerInfo.icon = url;

      this.selectIconTypeVisible = false;
      this.selectIconVisible = false;
      this.selectIconExactVisible = false;
    },
    getDataByVarId(id) {
      var ret = "<div style='display: flex;'>";
      for (var index in this.varList) {
        if (this.varList[index].id == id) {
          ret += `<div>${this.varList[index].variableName}:</div><div style="margin-left: auto">${this.varList[index].curValue}</div>`
        }
      }
      return ret + "</div>";
    },
    initInfo() {
      this.markerInfoJSON = [];
      this.markers = [];
      //预览模式
      if(this.is_show)
      {
        setTimeout(()=>{
          self.markerInfoJSON = JSON.parse(window.localStorage.getItem("map_show_data"));
          for (let index in self.markerInfoJSON) {
          if (self.markerInfoJSON[index]) {
            self.autoAddMarker(self.markerInfoJSON[index]);
          }
      }},500);
      }else {
        let data = {
          id: this.productId,  // 页面id
          companyId: this.companyId
        }
        this.$axiosRequest({
          url: API.getProductById,
          method: 'POST',
          data: data,
          header: this.header,
          success: res => {
            let sup = JSON.parse(res.data.product.tableData);
            console.log(sup);
            self.markerInfoJSON = sup.data;
            for (let index in self.markerInfoJSON) {
              if (self.markerInfoJSON[index]) {
                self.autoAddMarker(self.markerInfoJSON[index]);
              }
            }
          }
        })
      }
    },
    selectActionProduct(index) {
      this.markerInfo.productName = this.productList[index].title;
      this.markerInfo.productId = this.productList[index].id;
      this.markerInfo.productType = this.productList[index].product_type;
    },
    //更新TableData的Json
    updateJson(){
      this.markerInfoJSON = [];
      for (let index in this.markers) {
        let elem = this.markers[index];
        if (elem) {
          this.markerInfoJSON.push({
            icon: this.imgUrls[index],
            lat: elem.position.lat,
            lng: elem.position.lng,
            height: elem.getIcon().size.getHeight(),
            width: elem.getIcon().size.getWidth(),
            productId: this.actions[index].productId,
            productName: this.actions[index].productName,
            productType: this.actions[index].productType,
            actionType: this.actions[index].actionType,
            varIds: this.actions[index].varIds,
          });
        }
      }
    },
    //进入预览模式
    async handleShow(){
      this.updateJson();
      window.localStorage.setItem("map_show_data", JSON.stringify(this.markerInfoJSON));
      let redirectUrl = await generatePath(this.productId, this.companyId);
      console.log(redirectUrl);
      redirectUrl += `&is_show=true`
      handleRedirect(redirectUrl);
    },
    saveInfo() {
      this.updateJson();
      let newData = {
        product_type: 1,
        data: this.markerInfoJSON,
        center:map.getCenter(),  //记录放大和地图的焦点
        zoom:map.getZoom(),
      }
      console.log("看我看我看啊我",JSON.stringify(newData))
      this.$axiosRequest({
        url: API.updateProduct,                         //后面可能修改
        method: 'POST',
        data: {
          companyId: this.companyId,
          id: this.productId,
          tableData: JSON.stringify(newData)
        },
        header: this.header,
        success: res => {
          if (res.status == 200) {
            if (res.data == -1 || res.data == -2) {
              this.$message({
                message: '未保存成功，请重试！',
              });
            } else if (res.data > 0) {
              this.$message({
                message: '修改成功',
                type: 'success',
              });
            }
          }
        }
      })
    },
    getProductPublishedList() {
      let data = {
        companyId: this.companyId,
      }

      this.$axiosRequest({
        url: API.getProductPublishedList,
        method: 'POST',
        data: data,
        header: this.header,
        success: res => {
          this.productList = res.data["productPublishedList"];
        }
      });
    },
    checkVariableInList(index) {
      if (!this.markerInfo.varIds) return null;
      return this.markerInfo.varIds[index];
    },
    handleVariable(index) {
      if (!this.markerInfo.varIds) {
        this.markerInfo.varIds = [];
      }
      if (!this.markerInfo.varIds[index]) {
        this.$set(this.markerInfo.varIds, index, true);
      } else {
        this.$set(this.markerInfo.varIds, index, false);
      }
    },
    initVariableList() {
      this.$axiosRequest({
        url: API.getVariableList,
        method: 'POST',
        data: {
          id: this.productId,  // 页面id
          companyId: this.companyId
        },
        header: this.header,
        success: res => {
          this.varList = res.data["variableList"];
        }
      });
    },
  },
}
</script>

<style>
.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
